import { NgModule } from '@angular/core';

import { DoScrollDirective } from './do-scroll.directive';

@NgModule({
    imports: [],
    exports: [ DoScrollDirective ],
    declarations: [DoScrollDirective],
    providers: [],
})
export class DoScrollModule { }
